import { testimonials } from "@/mocks/testimonials";

export default function Testimonials() {
  return (
    <section className="w-full py-16 md:py-24 bg-secondary-50/50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-start justify-between gap-6 mb-10 md:mb-14">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <span className="w-2 h-2 rounded-full bg-accent-500"></span>
              <span className="w-2 h-2 rounded-full bg-accent-400"></span>
              <span className="w-2 h-2 rounded-full bg-accent-300"></span>
            </div>
            <span className="text-xs font-semibold uppercase tracking-widest text-foreground-400">
              User Reviews
            </span>
            <h2 className="mt-2 text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight">
              What Our <span className="italic font-light">Buyers</span> Say
            </h2>
            <p className="mt-3 text-sm text-foreground-500 max-w-md">
              Real feedback from users who rely on the ACBuy spreadsheet system for their order management.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {testimonials.map((t) => (
            <div
              key={t.id}
              className="bg-background-50 rounded-2xl p-5 md:p-6 border border-background-200/60"
            >
              <div className="flex items-center gap-1 mb-4">
                {[...Array(t.rating)].map((_, i) => (
                  <span key={i} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-accent-500 text-sm"></i>
                  </span>
                ))}
                {[...Array(5 - t.rating)].map((_, i) => (
                  <span key={i} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-background-300 text-sm"></i>
                  </span>
                ))}
              </div>
              <h4 className="text-sm md:text-base font-bold text-foreground-900 mb-2">
                Excellent ACBuy Spreadsheet System
              </h4>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                {t.text}
              </p>
              <div className="flex items-center gap-3 mt-4 pt-4 border-t border-background-200/60">
                <div className="w-9 h-9 rounded-full bg-secondary-200 flex items-center justify-center text-xs font-bold text-secondary-700">
                  {t.avatar}
                </div>
                <div>
                  <p className="text-xs font-semibold text-foreground-800">{t.name}</p>
                  <p className="text-xs text-foreground-400">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}